import React, { useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { DatePicker, Input, Select } from "common/InputForm";
import { CustomButton } from "components/form";
import { toastMessage } from "utils/toastMessage";
import { regex } from "utils/formValidator";
import { addEventApi } from "services/event";
import { IoCloudUploadOutline } from "react-icons/io5";
import { GoX } from "react-icons/go";
import useButtonLoader from "common/UseButtonLoader";
import JoditEditor from "jodit-react";

const AddEvent = () => {
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Submit");
  const [errors, setErrors] = useState({});
  const { imageFileRegex } = regex;
  const navigate = useNavigate();
  const editor = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      placeholer: "",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monaco,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );

  const [formData, setFormData] = useState({
    image: "",
    imageName: null,
    title: "",
    description: "",
    date: "",
    time: "",
    venue: "",
    mode: "",
    duration: "",
    url: "",
    type: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "duration") {
      // Allow only numbers and restrict to a maximum of 3 digits
      if (/^\d{0,3}$/.test(value)) {
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      }
    } else {
      // Allow other fields to be updated normally
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && imageFileRegex.test(file.name)) {
      const imageUrl = URL.createObjectURL(file);
      setFormData((prevData) => ({
        ...prevData,
        image: imageUrl,
        imageName: file,
      }));
    }
  };

  const handleImageRemove = () => {
    setFormData((prevData) => ({
      ...prevData,
      image: "",
      imageName: null,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.description)
      newErrors.description = "Description is required";
    if (!formData.date) newErrors.date = "Date is required";
    if (!formData.time) newErrors.time = "Time is required";

    // if (!formData.url) newErrors.url = "Url is required";
    if (!formData.mode) newErrors.mode = "Mode is required";
    if (!formData.type) newErrors.type = "Type is required";

    if (!formData.mode === "ofline") {
      if (!formData.venue) newErrors.venue = "Venue is required";
    }
    if (!formData.duration) newErrors.duration = "Duration is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const date =
    formData.date instanceof Date ? formData.date : new Date(formData.date); // Ensure date is a Date object

  const time =
    formData.time.length === 5 ? `${formData.time}:00` : formData.time; // Ensure "HH:MM:SS"

  // Construct local date-time string
  const dateTimeString = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${time}`;

  // Convert to Date object
  const dateTime = new Date(dateTimeString);

  // Append to FormData

  console.log(dateTime, "dateTime");

  console.log(errors, "event err");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setButtonLoaders(true);
    try {
      const formDatas = new FormData();
      formDatas.append("title", formData.title);
      formDatas.append("description", formData.description);
      formDatas.append("dateTime", dateTime.toISOString());
      formDatas.append("venue", formData.venue);
      formDatas.append("mode", formData.mode);
      formDatas.append("type", formData.type);
      // formDatas.append("url", formData.url);
      formDatas.append("duration", formData.duration);
      if (formData.imageName) formDatas.append("image", formData.imageName);
      const res = await addEventApi(formDatas);
      console.log(res, "res");
      if (res?.data?.status === 200) {
        toastMessage(res?.data?.message, "success", "addEvent");
        navigate(-1);
      }
    } catch (e) {
      toastMessage(e.message, "error", "addEvent");
    } finally {
      setButtonLoaders(false);
    }
  };
  const handleStartDate = (date) => {
    setFormData((prevData) => ({
      ...prevData,
      date: date,
    }));
  };
  console.log(formData, "formData");
  return (
    <div className="addClass">
      <div className="dashboard_title has_child">
        <h3>
          <Link to={-1}>
            <IoMdArrowRoundBack />
          </Link>{" "}
          Add Event
        </h3>
        <CustomButton
          type="button"
          className="button"
          ref={buttonLoaders}
          onClick={handleSubmit}
        >
          Save and Submit
        </CustomButton>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="form_field_wrap">
              <div className="form_field">
                <Input
                  type="text"
                  label="Title"
                  name="title"
                  placeholder="Enter Title"
                  value={formData.title}
                  onChange={handleInputChange}
                  error={errors.title}
                />
              </div>
              <div className="form_field">
                <Input
                  type="text"
                  label="Duration (in min)"
                  name="duration"
                  placeholder="Enter Duration"
                  value={formData.duration}
                  onChange={handleInputChange}
                  error={errors.duration}
                />
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <DatePicker
                  label="Date"
                  name="date"
                  selected={formData.date}
                  placeholder="Date"
                  onChange={(date) => handleStartDate(date)}
                  error={errors.date}
                  autoComplete="off"
                />
              </div>
              <div className="form_field">
                <Input
                  type="time"
                  label="Time"
                  name="time"
                  value={formData.time}
                  onChange={handleInputChange}
                  error={errors.time}
                />
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Mode</label>
                <select
                  className="form-control input"
                  name="mode"
                  value={formData.mode}
                  onChange={handleInputChange}
                >
                  <option value="">Select Mode</option>
                  <option value="online">Online</option>
                  <option value="ofline">Ofline</option>
                </select>
                {errors?.mode && <span className="error">{errors.mode}</span>}
              </div>
              <div className="form_field">
                {formData.mode !== "online" && (
                  <Input
                    type="text"
                    label="Venue"
                    name="venue"
                    placeholder="Enter Venue"
                    value={formData.venue}
                    onChange={handleInputChange}
                    error={errors.venue}
                  />
                )}
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <label>Description</label>
                <JoditEditor
                  ref={editor}
                  value={formData.description}
                  config={config}
                  tabIndex={1}
                  onBlur={(newContent) => {
                    setFormData((prevData) => ({
                      ...prevData,
                      description: newContent,
                    }));
                    setErrors((prevData) => ({
                      ...prevData,
                      description: null,
                    }));
                  }}
                />
              </div>

              <div className="form_field">
                <label className="label">Image</label>
                <div className="upload_button_wrap">
                  <label htmlFor="upload_image" className="upload_button input">
                    <IoCloudUploadOutline className="icon" />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      id="upload_image"
                    />
                    <span className="text">Select file to upload</span>
                  </label>
                  <div className="image_preview_wrap">
                    {formData.image && (
                      <div className="image_preview">
                        <img src={formData.image} alt="Preview" width="300" />
                        <button
                          type="button"
                          className="remove_image_button"
                          onClick={handleImageRemove}
                        >
                          <GoX />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form_field">
                <label className="label">Type</label>
                <select
                  className="form-control input"
                  name="type"
                  value={formData.type}
                  onChange={handleInputChange}
                >
                  <option value="">Select Type</option>
                  <option value="free">Free</option>
                  <option value="paid">Paid</option>
                </select>
                {errors?.type && <span className="error">{errors.type}</span>}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEvent;
